import { render, staticRenderFns } from "./FinalLabModal.vue?vue&type=template&id=3dbcbd63"
import script from "./FinalLabModal.vue?vue&type=script&lang=js"
export * from "./FinalLabModal.vue?vue&type=script&lang=js"
import style0 from "./FinalLabModal.vue?vue&type=style&index=0&id=3dbcbd63&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports